const syncHiddenInput = (root) => {
    const surface = root.querySelector("[data-rcd-richtext-surface]");
    const input = root.querySelector("[data-rcd-richtext-input]");
    if (!surface || !input) {
        return;
    }

    input.value = surface.innerHTML.trim();
};

const updateToolbarState = (root) => {
    root.querySelectorAll("[data-rcd-richtext-cmd]").forEach((button) => {
        const command = button.dataset.rcdRichtextCmd;
        let active = false;
        try {
            active = document.queryCommandState(command);
        } catch {
            active = false;
        }

        button.classList.toggle("is-active", active);
    });
};

const runCommand = (root, command) => {
    const surface = root.querySelector("[data-rcd-richtext-surface]");
    if (!surface) {
        return;
    }

    surface.focus();

    if (command === "createLink") {
        const url = window.prompt("Link URL");
        if (!url) {
            return;
        }

        document.execCommand("createLink", false, url);
    } else {
        document.execCommand(command, false, null);
    }

    syncHiddenInput(root);
    updateToolbarState(root);
};

const initEditor = (root) => {
    if (root.dataset.rcdRichtextReady === "true") {
        return;
    }

    const surface = root.querySelector("[data-rcd-richtext-surface]");
    const input = root.querySelector("[data-rcd-richtext-input]");
    if (!surface || !input) {
        return;
    }

    root.dataset.rcdRichtextReady = "true";

    if (input.value) {
        surface.innerHTML = input.value;
    }

    surface.addEventListener("input", () => syncHiddenInput(root));
    surface.addEventListener("keyup", () => updateToolbarState(root));
    surface.addEventListener("mouseup", () => updateToolbarState(root));
    surface.addEventListener("blur", () => syncHiddenInput(root));

    root.querySelectorAll("[data-rcd-richtext-cmd]").forEach((button) => {
        button.addEventListener("click", (event) => {
            event.preventDefault();
            runCommand(root, button.dataset.rcdRichtextCmd);
        });
    });

    root.closest("form")?.addEventListener("submit", () => syncHiddenInput(root));
};

export const setupRcdRichTextEditors = (root = document) => {
    const editors = [];
    if (root instanceof Element && root.matches("[data-rcd-richtext]")) {
        editors.push(root);
    }

    root.querySelectorAll?.("[data-rcd-richtext]").forEach((editor) => editors.push(editor));
    editors.forEach(initEditor);
};
